import { withJsonFormsControlProps } from '@jsonforms/react';
import type { ControlProps } from '@jsonforms/core';
import { MultiSelect } from '../../Multiselect';
import type { OptionType } from '../../Multiselect';

type MultiSelectControlProps = ControlProps & {
  options?: OptionType<string>[];
};

const MultiSelectControl = ({
  data,
  handleChange,
  path,
  label,
  required,
  schema,
  options,
}: MultiSelectControlProps) => {
  const schemaOptions = (schema as any)?.['x-options'] || {};
  const controlOptions = options || schemaOptions.options || [];

  const handleMultiSelectChange = (newValues: string[]) => {
    handleChange(path, newValues);
  };

  return (
    <div className="mb-4">
      <MultiSelect<string>
        options={controlOptions}
        label={label ?? schema?.title}
        value={data || []}
        onChange={handleMultiSelectChange}
      />
      {required && (
        <input
          type="text"
          required
          value={data?.length > 0 ? 'valid' : ''}
          style={{ display: 'none' }}
          readOnly
        />
      )}
    </div>
  );
};

const MultiSelectControlWithProps = (props: any) => {
  const options = props.config?.options || [];

  return (
    <MultiSelectControl
      {...props}
      options={Array.isArray(options) ? options : []}
    />
  );
};

export default withJsonFormsControlProps(MultiSelectControlWithProps);
